import {Injectable} from '@angular/core';
import {CrudService} from './crud.service';
import {Operator} from '../models/operator';
import {HttpClient} from '@angular/common/http';
import {TableQueryParams} from '../models/table-query-params';
import {PagedResponse} from '../models/paged-response';
import {TableUtils} from '../utils/table.utils';
import {Invoice} from '../models/invoice';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService extends CrudService<Operator> {
    constructor(http: HttpClient) {
        super(http, 'invoices');
    }

    async getInvoicesByMonth(month: number) {
        return this.http
            .get<Invoice[]>(`${this.endpoint}/all?month=${month}`)
            .toPromise();
    }

    getAll(params: TableQueryParams, operatorId: string = null): Promise<PagedResponse<Operator>> {
        const queryParams = TableUtils.prepareForApiParams(params);
        if(operatorId) {
            queryParams.operator = operatorId;
        }
        return this.http
            .get<PagedResponse<Operator>>(this.endpoint, {params: queryParams})
            .toPromise();
    }

    async markAsPaid(invoiceId) {
        return await this.http.put<any>(`invoices/${invoiceId}/markAsPaid`, {}).toPromise();
    }

    async getDownloadUrl(invoiceId): Promise<{ url: string }> {
        return await this.http.get<{ url: string }>(`invoices/${invoiceId}/download`).toPromise();
    }

    async generate(operator: Operator) {
        return await this.http.post<any>('invoices/generate', {operatorId: operator._id}).toPromise();
    }
}
